module.exports = __webpack_public_path__ + "static/semantic-icon-circular-806888c746cf199da447502cf6635fea.png";